class View {
  constructor(namespace) {
    this.namespace = namespace;
  }

  init() {
    this.configureElements();
    this.bindElements();
  }

  configureElements() {}

  bindElements() {}

  bind(el, event, callback) {
    return el.unbind(`${event}.${this.namespace}`).bind(`${event}.${this.namespace}`, callback);
  }
}

module.exports = View;
